import type { ComponentRegistry } from "@json-render/react";
import type { AppComponentName } from "../catalog";
import {
  StackComponent,
  InlineComponent,
  GridComponent,
  CardComponent,
  SectionComponent,
  TabsComponent,
  TabComponent,
  SeparatorComponent,
  HeadingComponent,
  TextComponent,
  FieldComponent,
  MetricComponent,
  BadgeComponent,
  AlertComponent,
  AgentNoteComponent,
  EmptyStateComponent,
  ProgressComponent,
  SkeletonComponent,
  TableComponent,
  ListComponent,
  ButtonComponent,
  TextInputComponent,
  TextAreaComponent,
  SelectComponent,
  CheckboxComponent,
  SwitchComponent,
  IconComponent,
} from "./components";
import {
  AreaChartComponent,
  BarChartComponent,
  CustomChartComponent,
  LineChartComponent,
  PieChartComponent,
  ScatterChartComponent,
} from "./charts";
import { LinkComponent } from "./links";
import {
  ConfirmDialogComponent,
  DialogComponent,
  HoverCardComponent,
  OverlayFooterComponent,
  PopoverComponent,
  ResizablePanelComponent,
  ResizablePanelsComponent,
  SheetComponent,
  TooltipComponent,
} from "./overlays";

/** Registry keyed by catalog component name; `satisfies` fails the build if the two drift. */
export const appComponents = {
  Stack: StackComponent,
  Inline: InlineComponent,
  Grid: GridComponent,
  Card: CardComponent,
  Section: SectionComponent,
  Tabs: TabsComponent,
  Tab: TabComponent,
  Separator: SeparatorComponent,
  Heading: HeadingComponent,
  Text: TextComponent,
  Field: FieldComponent,
  Metric: MetricComponent,
  Badge: BadgeComponent,
  Alert: AlertComponent,
  AgentNote: AgentNoteComponent,
  EmptyState: EmptyStateComponent,
  Progress: ProgressComponent,
  Skeleton: SkeletonComponent,
  Table: TableComponent,
  List: ListComponent,
  BarChart: BarChartComponent,
  LineChart: LineChartComponent,
  AreaChart: AreaChartComponent,
  PieChart: PieChartComponent,
  ScatterChart: ScatterChartComponent,
  Chart: CustomChartComponent,
  Icon: IconComponent,
  Link: LinkComponent,
  Button: ButtonComponent,
  TextInput: TextInputComponent,
  TextArea: TextAreaComponent,
  Select: SelectComponent,
  Checkbox: CheckboxComponent,
  Switch: SwitchComponent,
  Popover: PopoverComponent,
  Dialog: DialogComponent,
  ConfirmDialog: ConfirmDialogComponent,
  Tooltip: TooltipComponent,
  HoverCard: HoverCardComponent,
  Sheet: SheetComponent,
  OverlayFooter: OverlayFooterComponent,
  ResizablePanels: ResizablePanelsComponent,
  ResizablePanel: ResizablePanelComponent,
} satisfies Record<AppComponentName, ComponentRegistry[string]>;
